import { useEffect, useRef, useState } from 'react';
import { Icon } from './Icon';

export const Notice = ({ message, onDismiss, onViewBag }) => {
  const [paused, setPaused] = useState(false);
  const dismissRef = useRef(onDismiss);
  dismissRef.current = onDismiss;

  useEffect(() => {
    if (paused) return undefined;
    const timer = window.setTimeout(() => dismissRef.current(), 3500);
    return () => window.clearTimeout(timer);
  }, [message, paused]);

  const isAddedToBag = /added to bag/i.test(message);

  return (
    <div
      className="notice"
      role="status"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <span className="notice-dot" aria-hidden="true" />
      <span className="notice-message">{message}</span>
      {isAddedToBag && <button className="notice-link" onClick={onViewBag}>View bag</button>}
      <button className="notice-close" aria-label="Dismiss notification" onClick={onDismiss}><Icon>×</Icon></button>
    </div>
  );
};
